/* ============================================================
   SENTINEL COLLECTION — sentinel-collection.js
   Tiny progressive-enhancement layer. Smooth-scroll the hero CTA
   anchor, reveal-on-scroll the major sections. No deps, no build.
   ============================================================ */

(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function initScrollAnchors() {
    var links = document.querySelectorAll('[data-scol-scroll]');
    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        var href = link.getAttribute('href') || '';
        if (!href.startsWith('#')) return;
        var target = document.querySelector(href);
        if (!target) return;
        e.preventDefault();
        var top = target.getBoundingClientRect().top + window.pageYOffset - 16;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });
  }

  function initScrollReveal() {
    if (!('IntersectionObserver' in window)) {
      /* Fallback: just reveal everything. */
      document.querySelectorAll('.scol-uc, .scol-compare, .scol-grid, .scol-decide, .scol-quality, .scol-faq').forEach(function (el) {
        el.classList.add('scol-section--revealed');
      });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('scol-section--revealed');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.05, rootMargin: '0px 0px -10% 0px' });
    document.querySelectorAll('.scol-uc, .scol-compare, .scol-grid, .scol-decide, .scol-quality, .scol-faq').forEach(function (el) {
      io.observe(el);
    });
  }

  ready(function () {
    initScrollAnchors();
    initScrollReveal();
  });
})();
